import "./DraggerInside.css"

import { InboxOutlined } from "@ant-design/icons"
import React from "react"

const DraggerInside = (): React.ReactElement => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
          <InboxOutlined className="dragger-icon" />
          <span className="dragger-text">Clique ou arraste a imagem</span>
          <span className="dragger-extensions">.PNG, .JPG e .JPEG</span>
        </div>
  )
}

export default DraggerInside
